export default __webpack_public_path__ + "static/media/apartment.7fcdc558.svg";